<template>
  <div>
    <van-dialog
      v-model="visible"
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="dialog"
    >
      <van-image
        v-if="visible"
        class="image"
        :src="require('../../../../../public/image/1.gif')"
      ></van-image>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'readmeDialog',
  props: {
    visible: Boolean,
    titleImage: String,
    backgroundImage: String,
    removeImage: String,
    textImage: String
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          let _this = this
          this.$nextTick(() => {
            setTimeout(() => {
              _this.removeClick()
            }, 2210)
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // restartVideo() {
    //   this.$nextTick(() => {
    //     const video = this.$refs.video
    //     console.log(video)
    //     video.currentTime = 0
    //     video.play()
    //   })
    // },
    removeClick() {
      this.$emit('changeVisible', false)
      this.$emit('showGetRewards')
    }
  }
}
</script>

<style lang="scss" scoped>
.video::-webkit-media-controls-enclosure {
  display: none;
}
video::-webkit-media-controls-panel {
  width: calc(100% + 30px); /* Adjust number to hide play/pause buttons */
}
.dialog {
  //   border-radius: 0px;
  //   height: 160px;
  .image {
    display: block;
  }
  /deep/ .van-dialog__content {
    // height: 160px;
  }
  //   .video {
  //     width: 320px;
  //     height: 160px;
  //   }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/videoDialog/index.vue